var map = {
	"./AS.png": "H97d",
	"./Australia.png": "Nu5K",
	"./Belanda.png": "XSS8",
	"./Inggris.png": "7Trz",
	"./Itali.png": "UGwD",
	"./Jepang.png": "0BsF",
	"./Jerman.png": "6PGW",
	"./Kanada.png": "zJ+4",
	"./Korea.png": "pikd",
	"./Malaysia.png": "umrC",
	"./Perancis.png": "Mlox",
	"./Taiwan.png": "Fg30",
	"./Tiongkok.png": "Bt5X",
	"./Turki.png": "6iZ8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UBmJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark ^\.\/.*\.png$
// module id = UBmJ
// module chunks = 1